import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How big is the proposed solar farm?",
    a: "The site is approximately 100 hectares overall, spread across 21 fields. Solar panel arrays will cover around 70 hectares; the remaining area is used for the separate substation, habitat areas, access tracks and buffers around dwellings and roads.",
  },
  {
    q: "Will it be visible from my house or the road?",
    a: "The fields are already well enclosed by mature hedgerows, which screen most of the project from view. Where additional screening is needed it will be added, and panels are set back from homes and roads. A Landscape and Visual Impact Assessment is being carried out as part of the application.",
  },
  {
    q: "Will there be glint and glare?",
    a: "A specialist Glint & Glare assessment models any potential effects along roads and at residential properties. Where any effect is identified, mitigation will be designed into the layout — typically through orientation or additional screening.",
  },
  {
    q: "What happens to the land underneath the panels?",
    a: "Panels are mounted on steel piles with rows angled and spaced so sunlight reaches the ground. Low-level grazing can continue, and reduced stocking helps the soil to recover. Biodiversity tends to improve over time under managed solar arrays.",
  },
  {
    q: "How long does construction take, and how disruptive is it?",
    a: "Construction is expected to take 18–24 months. A Traffic Management Plan covers dedicated haul routes, safety procedures and road-cleaning measures. A Community Liaison Officer is in place specifically to keep residents updated and to handle queries.",
  },
  {
    q: "Is this permanent?",
    a: "No. The steel piles are fully removable, and at the end of operational life the ground is reinstated. The intention is for the fields to return in better condition than before, with healthier soils and stronger hedgerows.",
  },
  {
    q: "Can I still have a say after the planning application is submitted?",
    a: "Yes. Once the application is lodged with Galway County Council, it goes through the statutory public consultation process. We strongly encourage you to engage with us now — the earlier the input, the more we can incorporate into the design before submission.",
  },
];

export default function FaqSection() {
  return (
    <section className="bg-[#F2EFE8] border-y border-[#E0DCD3]" data-testid="faq-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4 reveal">
            <p className="overline mb-4">Common questions</p>
            <h2 className="font-serif-display text-3xl lg:text-4xl tracking-tight">
              The questions we get asked most often.
            </h2>
            <p className="mt-5 text-[14.5px] leading-relaxed text-[#63635E]">
              Don’t see your question here? Send it via the message form above or
              raise it in person at one of the information days.
            </p>
          </div>

          <div className="lg:col-span-7 lg:col-start-6 reveal">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-[#E0DCD3] last:border-b-0"
                >
                  <AccordionTrigger className="text-left font-serif-display text-lg tracking-tight py-5 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[14.5px] leading-relaxed text-[#2A2B2A]/85 pb-5">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
